import React, { memo } from "react";
import { Fade } from "react-awesome-reveal";
import { PurpleButton } from "../../../../../Components/Buttons/PurpleButton";
import {
  MintHome,
  MintImage,
  MintUpload,
  MintSample,
} from "../../../../../AssetComponents/Images";

const MintWelcomePage = memo(({ onNext, onSkip }) => {
  return (
    <div className="w-full h-full flex flex-col">
      {/* Main content area - no overflow, natural flow */}
      <div className="flex-1 px-4 lg:px-8">
        {/* Mobile Version */}
        <div className="lg:hidden w-full h-full flex flex-col justify-center py-4">
          <div className="w-full max-w-md mx-auto flex flex-col space-y-4">
            <div className="text-xl sm:text-2xl font-semibold text-center">
              Get your Apartments ready for rental
            </div>
            <div className="text-xs sm:text-sm text-center text-gray-600 px-2">
              Follow these simple steps below and mint your apartment
            </div>
            
            <Fade cascade direction="left" damping={0.2}>
              <div className="w-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)] rounded-[12px] p-3 bg-white">
                <div className="flex gap-2 items-start w-full">
                  <div className="flex-shrink-0">
                    <MintHome />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm sm:text-base font-semibold mb-1">
                      Tell us about your place
                    </div>
                    <div className="text-xs sm:text-sm text-gray-600">
                      Share some basic info, like where it is and how many
                      guests can stay
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="w-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)] rounded-[12px] p-3 bg-white">
                <div className="flex gap-2 items-start w-full">
                  <div className="flex-shrink-0">
                    <MintImage />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm sm:text-base font-semibold mb-1">
                      Make it stand out
                    </div>
                    <div className="text-xs sm:text-sm text-gray-600">
                      Add 5 or more photos plus a title and description. We'll
                      help you out.
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="w-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)] rounded-[12px] p-3 bg-white">
                <div className="flex gap-2 items-start w-full">
                  <div className="flex-shrink-0">
                    <MintUpload />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm sm:text-base font-semibold mb-1">
                      Finish up and publish
                    </div>
                    <div className="text-xs sm:text-sm text-gray-600">
                      Choose if you'd like to start with an experienced guest,
                      set a starting price, and publish your listing.
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            
            {/* Get Started Button */}
            <div className="w-full flex justify-center pt-3">
              <PurpleButton
                text="Get Started"
                onClick={onNext}
                className="w-full max-w-xs"
              />
            </div>
          </div>
        </div>

        {/* Desktop Version */}
        <div className="hidden lg:flex gap-8 justify-center items-center w-full h-full py-8">
          <div className="w-full max-w-lg flex flex-col space-y-6">
            <div className="text-3xl font-semibold text-center">
              Get your Apartments ready for rental
            </div>
            <div className="text-base text-center text-gray-600">
              Follow these simple steps below and mint your apartment
            </div>
            
            <Fade cascade direction="left" damping={0.2}>
              <div className="w-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)] rounded-[16px] p-6 bg-white">
                <div className="flex gap-4 items-center w-full">
                  <MintHome />
                  <div>
                    <div className="text-xl font-semibold mb-2">
                      Tell us about your place
                    </div>
                    <div className="text-gray-600">
                      Share some basic info, like where it is and how many
                      guests can stay
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="w-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)] rounded-[16px] p-6 bg-white">
                <div className="flex gap-4 items-center w-full">
                  <MintImage />
                  <div>
                    <div className="text-xl font-semibold mb-2">
                      Make it stand out
                    </div>
                    <div className="text-gray-600">
                      Add 5 or more photos plus a title and description. We'll
                      help you out.
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="w-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.8),2px_2px_6px_0px_rgba(187,195,206,0.6)] rounded-[16px] p-6 bg-white">
                <div className="flex gap-4 items-center w-full">
                  <MintUpload />
                  <div>
                    <div className="text-xl font-semibold mb-2">
                      Finish up and publish
                    </div>
                    <div className="text-gray-600">
                      Choose if you'd like to start with an experienced guest,
                      set a starting price, and publish your listing.
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            
            {/* Get Started Button */}
            <div className="w-full flex justify-center pt-6">
              <PurpleButton
                text="Get Started"
                onClick={onNext}
                className="w-auto px-8"
              />
            </div>
          </div>
          
          <Fade duration={5000}>
            <MintSample className="h-[500px] w-auto" />
          </Fade>
        </div>
      </div>
    </div>
  );
});

MintWelcomePage.displayName = "MintWelcomePage";

export default MintWelcomePage;
